import { TrendingUp, IndianRupee, Percent } from "lucide-react";

export default function HeadlineCard({
  savings,
  subtitle,
  score,
  totalFees,
  totalRewards,
}) {
  const scoreColor =
    score >= 70
      ? "text-emerald-400"
      : score >= 40
        ? "text-amber-400"
        : "text-red-400";

  const scoreBorder =
    score >= 70
      ? "border-emerald-500/20"
      : score >= 40
        ? "border-amber-500/20"
        : "border-red-500/20";

  const scoreGlow =
    score >= 70
      ? "shadow-emerald-500/10"
      : score >= 40
        ? "shadow-amber-500/10"
        : "shadow-red-500/10";

  return (
    <div
      className="glass-card rounded-2xl p-6 md:p-8 transition-all duration-300 h-full"
      data-testid="headline-card"
    >
      <div className="flex items-start justify-between mb-6">
        <div className="flex-1">
          <p className="text-xs font-medium text-white/30 uppercase tracking-[0.15em] mb-2">
            Your Yearly Gain
          </p>
          <p
            className="font-heading font-extrabold text-4xl sm:text-5xl text-white tracking-tight"
            data-testid="yearly-gain-amount"
          >
            {savings}
          </p>
          <p className="mt-2 text-sm text-white/40 leading-relaxed">
            {subtitle}
          </p>
        </div>

        {/* Efficiency Score */}
        <div
          className={`flex flex-col items-center justify-center w-20 h-20 rounded-2xl border ${scoreBorder} bg-white/[0.02] shadow-lg ${scoreGlow}`}
          data-testid="efficiency-score"
        >
          <span className={`font-mono font-bold text-2xl ${scoreColor}`}>
            {score}
          </span>
          <span className="text-[10px] text-white/25 font-medium mt-0.5">
            /100
          </span>
        </div>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-3 gap-3">
        <div className="bg-white/[0.03] rounded-xl p-3 border border-white/[0.04]">
          <div className="flex items-center gap-1.5 mb-1">
            <IndianRupee className="w-3.5 h-3.5 text-white/25" />
            <span className="text-[10px] text-white/25 font-medium">
              Annual Fees
            </span>
          </div>
          <p
            className="font-mono font-semibold text-sm text-white/70"
            data-testid="total-fees"
          >
            {totalFees?.toLocaleString("en-IN")}
          </p>
        </div>
        <div className="bg-white/[0.03] rounded-xl p-3 border border-white/[0.04]">
          <div className="flex items-center gap-1.5 mb-1">
            <TrendingUp className="w-3.5 h-3.5 text-emerald-400/50" />
            <span className="text-[10px] text-white/25 font-medium">Rewards</span>
          </div>
          <p
            className="font-mono font-semibold text-sm text-emerald-400"
            data-testid="total-rewards"
          >
            {totalRewards?.toLocaleString("en-IN")}
          </p>
        </div>
        <div className="bg-white/[0.03] rounded-xl p-3 border border-white/[0.04]">
          <div className="flex items-center gap-1.5 mb-1">
            <Percent className="w-3.5 h-3.5 text-purple-400/50" />
            <span className="text-[10px] text-white/25 font-medium">
              Efficiency
            </span>
          </div>
          <p className="font-mono font-semibold text-sm text-purple-400">
            {score}%
          </p>
        </div>
      </div>
    </div>
  );
}
